import React, { useRef } from 'react';
import styles from './RadioButton.module.scss';
import cx from 'classnames';
import Highlighter from 'react-highlight-words';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';

// variant = 'primary' || 'secondary
// type = 'radiobutton' || 'checkbox'
// size = 'small' || medium
const RadioButton = ({
  checked,
  onChange = null,
  size = 'small',
  label,
  additionalLabel = '',
  id,
  type = 'checkbox',
  variant = 'primary',
  className,
  disabled = false,
  isHighlight,
  searchInput = '',
  isSelectByTitle = false,
}) => {
  const handleChange = e => {
    if (typeof e?.stopPropagation === 'function') {
      e.stopPropagation();
    }

    onChange && onChange(e);
  };

  // Accessible action can be available throw two way if 'isSelectByTitle' is true
  const accessibleContainerRef = useAccessibleClick(() => handleChange({ target: { id } }));
  const containerRef = isSelectByTitle ? accessibleContainerRef : useRef(null);

  const inputRef = useAccessibleClick(handleChange);

  return (
    <div tabIndex={0} ref={containerRef} className={cx(styles.container, className)}>
      <input
        tabIndex={0}
        ref={inputRef}
        type={'checkbox'}
        id={id}
        name={id}
        checked={checked}
        onClick={handleChange}
        readOnly={onChange == null}
        className={cx(styles.customCheckbox, { [styles.disabled]: disabled, [styles.readonly]: !onChange }, styles[size])}
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={cx(styles[variant], styles[type], styles[size], {
          [styles.disabled]: disabled,
          [styles.margin]: label || additionalLabel,
        })}
      >
        {additionalLabel ? <>{additionalLabel}&nbsp;</> : null}
        {isHighlight ? (
          <Highlighter
            highlightClassName="wordHighlighter"
            searchWords={[searchInput]}
            autoEscape
            textToHighlight={label}
            className={styles.highlighter}
          />
        ) : (
          label
        )}
      </label>
    </div>
  );
};

export default RadioButton;
